<template>
  <div id="app">
    <mahjong-calculator />
  </div>
</template>

<script>
import MahjongCalculator from './components/mahjong-calculator.vue'

export default {
  name: 'app',
  components: {
    MahjongCalculator
  }
}
</script>
